import { Avatar } from "@mui/material";

import { RobotoMarkdown } from "@/shared/components/RobotoMarkdown";
import { type UIComment } from "@/shared/domain/comments/hooks/useUIComment";

import styles from "./CommentCard.module.css";
import { CommentHeader } from "./CommentHeader";

interface CommentCardProps {
  comment: UIComment;
}

export function CommentCard({ comment }: CommentCardProps) {
  return (
    <div className={styles.card}>
      <CommentAuthorAvatar
        avatarUrl={comment.avatarUrl}
        isSystemUser={comment.isSystemUser}
      />
      <div className={styles.content}>
        <CommentHeader comment={comment} />
        <div className={styles.commentText}>
          <RobotoMarkdown
            content={comment.comment_text}
            className={styles.commentMarkdown}
          />
        </div>
      </div>
    </div>
  );
}

interface CommentAuthorAvatar {
  isSystemUser: boolean;
  avatarUrl: string | undefined;
}

function CommentAuthorAvatar(props: CommentAuthorAvatar) {
  if (props.isSystemUser) {
    return (
      <Avatar className={styles.avatar}>
        <img alt="Roboto Logo" className={styles.avatar} src="/iconWhite.svg" />
      </Avatar>
    );
  }

  return (
    <Avatar
      className={styles.avatar}
      imgProps={{ referrerPolicy: "no-referrer" }}
      src={props.avatarUrl}
    />
  );
}
